import type { KeywordTypeValue, SelectOption, TimeRangeOption } from '@/app/KeywordTracker/types/aiModalTypes';

export const timeRangeOptions: TimeRangeOption[] = [
  { value: 'week', label: '۱ هفته', days: 7 },
  { value: 'month', label: '۱ ماه', days: 30 },
  { value: '3months', label: '۳ ماه', days: 90 },
  { value: '6months', label: '۶ ماه', days: 180 },
  { value: 'year', label: '۱ سال', days: 365 }
];

export const typeOptions: SelectOption<KeywordTypeValue>[] = [
  { value: 'I', label: 'اطلاعاتی (I)' },
  { value: 'N', label: 'مسیر (N)' },
  { value: 'T', label: 'تراکنشی (T)' },
  { value: 'C', label: 'تجاری (C)' },
  { value: 'long-tail', label: 'طولانی' },
  { value: 'trending', label: 'ترندی' },
  { value: 'high-search', label: 'جستجوی بالا' },
  { value: 'lsi', label: 'LSI' },
  { value: 'content-idea', label: 'ایده محتوا' },
  { value: 'local', label: 'محلی' },
  { value: 'low-competition', label: 'کم رقابت' },
  { value: 'fomo', label: 'FOMO' },
  { value: 'question', label: 'سوالی' },
  { value: 'suggested', label: 'پیشنهادی' }
];
